import React from 'react';
import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import {
  NoteCardHolderCreate,
  NoteCardHolderCreateVariables,
} from './__generated__/NoteCardHolderCreate';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import NOTE_CARD_HOLDER_CREATE from './NoteCardHolderCreate.graphql';

type CardAccountNotesSectionProps = Pick<
  NotesSectionProps,
  'listRefreshRequest'
> & {
  id: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const CardAccountNotesSection: React.FC<
  CardAccountNotesSectionProps
> = ({ id, data, loading, listRefreshRequest }) => {
  return (
    <GenericNotesSection<
      any,
      NoteCardHolderCreate, // TMutationResult
      NoteCardHolderCreateVariables // TMutationVariables
    >
      entityId={id}
      data={data}
      loading={loading}
      mutationDocument={NOTE_CARD_HOLDER_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
